module.exports = __webpack_public_path__ + "img/Account-Suite-Gradient.39341985.svg";